export default {
  SET_SEA_ROUTES(state, data) {
    state.seaRoutes = data;
  },
  SET_SEA_ROUTE_DETAIL_CONDITION(state, data) {
    state.seaRouteDetailCondition = data
  },
}